/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

type ShowToast = (kind: "success" | "error", message: string) => void;

/** Copies `value`, says how it went, and answers whether it worked. */
export async function copyWithToast(
  value: string,
  showToast: ShowToast,
  copied: string,
  failed: string,
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    showToast("success", copied);
    return true;
  } catch {
    showToast("error", failed);
    return false;
  }
}
